export const conferenceLogos = {
  aac: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/A-c.png',
    logoWhite: null,
    alt: 'A10',
    height: null,
  },
  acc: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/ACC-c.png',
    logoWhite: null,
    alt: 'ACC',
    height: null,
  },
  b10: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/B10-c.png',
    logoWhite: null,
    alt: 'B10',
    height: null,
  },
  big12: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/BIG12-c.png',
    logoWhite: null,
    alt: 'Big 12',
    height: null,
  },
  cusa: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/CUSA-c.png',
    logoWhite: null,
    alt: 'CUSA',
    height: null,
  },
  pac12: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/PAC12-c.png',
    logoWhite: null,
    alt: 'PAC12',
    height: null,
  },
  sec: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/SEC-c.png',
    logoWhite: null,
    alt: 'SEC',
    height: null,
  },
}
